import Immutable from "immutable";

export interface RewardPayload {
	id: number;
	slug: string;
	name: string;
	type: 'percent' | null;
	value: number | null;
}

export interface IRewardStore {
	id: number;
	slug: string;
	name: string;
	type: 'percent' | null;
	value: number | null;
}

const defaultRewardStore = Immutable.Record<IRewardStore>({
	id: 0,
	slug: "",
	name: "",
	type: null,
	value: null,
});

export default class RewardStore extends defaultRewardStore implements IRewardStore {}
